import { render, staticRenderFns } from "./tab_role.vue?vue&type=template&id=7e8f1f28&scoped=true&"
import script from "./tab_role.vue?vue&type=script&lang=js&"
export * from "./tab_role.vue?vue&type=script&lang=js&"
import style0 from "./tab_role.vue?vue&type=style&index=0&id=7e8f1f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f1f28",
  null
  
)

export default component.exports